const UTM_STORAGE = 'crc_utm_attribution';
const TRACE_SESSION = 'crc_trace_session';

function safeParse(json) {
  try {
    return JSON.parse(json) || {};
  } catch {
    return {};
  }
}

/** Read last captured UTM params (localStorage). */
export function readStoredUtm() {
  if (typeof window === 'undefined') return {};
  return safeParse(window.localStorage.getItem(UTM_STORAGE) || '{}');
}

/** Merge query-string UTM into localStorage (call on app load / navigation). */
export function captureUtmFromUrl() {
  if (typeof window === 'undefined') return;
  try {
    const p = new URLSearchParams(window.location.search);
    const next = {
      utm_source: p.get('utm_source') || undefined,
      utm_medium: p.get('utm_medium') || undefined,
      utm_campaign: p.get('utm_campaign') || undefined,
    };
    if (!next.utm_source && !next.utm_medium && !next.utm_campaign) return;
    const prev = readStoredUtm();
    window.localStorage.setItem(
      UTM_STORAGE,
      JSON.stringify({
        ...prev,
        ...next,
        capturedAt: new Date().toISOString(),
      }),
    );
  } catch {
    /* ignore */
  }
}

/**
 * Anonymous trace session (UUID) until a real assessment session exists.
 * Stored in sessionStorage so one browser tab = one trace id.
 */
export function getOrCreateTraceSessionId() {
  if (typeof window === 'undefined') return '';
  try {
    let id = window.sessionStorage.getItem(TRACE_SESSION);
    if (!id) {
      id = crypto.randomUUID();
      window.sessionStorage.setItem(TRACE_SESSION, id);
    }
    return id;
  } catch {
    return crypto.randomUUID();
  }
}
